import dayjs from "dayjs";

// Type definition for travel line data
export interface RouteLink {
  Line: {
    LineName: string;
    LineTypeName: string;
    Ogt: {
      OgtTrafficTypeGroupCssClass: string;
      OgtTrafficTypeIconCssClass: string;
      OgtTrafficTypeIconReplaceLineName: boolean;
    };
  };
}

// Split time into separate departure and arrival times
export function parseTravelTime(travelTime: string) {
  if (!travelTime || !travelTime.includes(" - ")) {
    return { departure: null, arrival: null };
  }

  const [departure, arrival] = travelTime.split(" - ");
  return { departure, arrival };
}

// Calculates total travel duration in text format
export function calculateTravelDuration(travelTime: string) {
  const { departure, arrival } = parseTravelTime(travelTime);
  if (!departure || !arrival) return "Not specified";

  const today = dayjs().format("YYYY-MM-DD");
  const departureTime = dayjs(`${today} ${departure}`, "YYYY-MM-DD HH:mm");
  const arrivalTime = dayjs(`${today} ${arrival}`, "YYYY-MM-DD HH:mm");

  const durationMinutes = arrivalTime.diff(departureTime, "minutes");
  const hours = Math.floor(durationMinutes / 60);
  const minutes = durationMinutes % 60;

  const hourText = hours === 1 ? "timme" : "timmar";
  const minuteText = minutes === 1 ? "minut" : "minuter";

  if (hours === 0) return `${minutes} ${minuteText}`;
  if (minutes === 0) return `${hours} ${hourText}`;
  return `${hours} ${hourText} ${minutes} ${minuteText}`;
}

// Ensures line data is consistently formatted before use
export function parseLineData(lineData: any): RouteLink[] {
  if (!Array.isArray(lineData)) return [];

  return lineData.map((item: any) => ({
    Line: {
      LineName: item?.Line?.LineName || "Unknown line",
      LineTypeName: item?.Line?.LineTypeName || "Unknown",
      Ogt: {
        OgtTrafficTypeGroupCssClass: item?.Line?.Ogt?.OgtTrafficTypeGroupCssClass || "",
        OgtTrafficTypeIconCssClass: item?.Line?.Ogt?.OgtTrafficTypeIconCssClass || "",
        OgtTrafficTypeIconReplaceLineName: item?.Line?.Ogt?.OgtTrafficTypeIconReplaceLineName ?? false,
      },
    },
  }));
}

export function createJourney(journeyData: any, headline: string, editPath: string) {
  return {
    Headline: headline,
    from: journeyData?.fromName || "Ej angivet",
    to: journeyData?.toName || "Ej angivet",
    date: journeyData?.date || "Ej angivet",
    depatureArrivalTime: journeyData?.travelTime || "Ej angivet",
    travelTime: calculateTravelDuration(journeyData?.travelTime || "Ej angivet"),
    switches: journeyData?.switches || "0",
    line: parseLineData(journeyData?.line),
    editPath
  };
}
